<template>
  <div
    class="videointerview-wrapper"
    :class="{ 'is-rec': recording, 'videointerview-wrapper--mobile': isMobile.any }"
  >
    <template v-if="badBrowser">
      <bad-browser-ios v-if="isIos && !isIosSafari" />
      <bad-browser v-else :locale="locale" />
    </template>

    <template v-else>
      <div class="video-container" :class="{ 'video-container--end': isFinishedStage }">
        <div
          :class="[
            'video_record_page',
            { 'img-block': !(companyLogo || logo), 'ended-block': isFinishedStage }
          ]"
        >
          <div v-if="companyLogo || logo" :class="['interview_top_block']">
            <div class="image">
              <img v-if="companyLogo || logo" :src="companyLogo || logo" alt="vcv" />
            </div>
          </div>

          <div class="interview-content" :class="{ 'interview-content--end': isFinishedStage }">
            <component
              :is="endWay"
              v-if="isFinishedStage && !isVideoresume"
              :candidate="candidate"
              :is-videoresume="isVideoresume"
              :interview="interview"
              class="vid-int-start"
            />

            <div v-else-if="isVideointerviewStage" class="vid-int-start">
              <videointerview-scene :interview="interview" :is-videoresume="isVideoresume" />
            </div>
          </div>

          <div v-if="isSubmitEnabled && !isFinishedStage && !isVideoresume" class="terms-wrapper">
            <span class="terms">
              {{ $tr('videoInterview.checkVideo.termsOfUse') }}
              <a
                :href="`https://vcv.${current_domain}/pages/user-agreement/`"
                target="_blank"
                rel="noopener"
              >
                {{ $tr('videoInterview.checkVideo.termsLink') }}
              </a>
            </span>
          </div>
        </div>

        <!-- <div
          v-if="isFinishedStage && !isVideoresume && getProcessName !== 'sportmaster_dm'"
          class="end-note"
        >
          <div v-html="$tr('interview.end.note2', { link: noteLink })"></div>
        </div> -->
      </div>
    </template>

    <div class="landscape-note" :class="{ 'landscape-note--mobile': isMobile.any }">
      {{ $tr('videointerview.landscapeNote') }}
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import InterviewTest from '@/components/interview/test/Scene.vue';
  import VideointerviewScene from '@/components/interview/videointerview/Scene.vue';
  import InterviewStart from '@/components/interview/Start.vue';
  import InterviewEnd from '@/components/interview/End.vue';
  import EndSportmaster from '@/process/sportmaster/components/interview/EndSportmaster';
  import EndVideoresume from '@/components/interview/EndVideoresume.vue';
  import BadBrowser from '@/components/interview/BadBrowser.vue';
  import BadBrowserIos from '@/components/interview/BadBrowserIos.vue';

  import IEBrowserDetector from '@/components/mixin/IEBrowserDetector.js';
  import SafariBrowserDetector from '@/components/mixin/SafariBrowserDetector.js';

  import isMobile from 'ismobilejs';
  import Vbutton from '@/components_new/vbutton/index.vue';

  const HTTP_FORBIDDEN = 403;

  export default {
    name: 'Default',
    components: {
      Vbutton,
      InterviewTest,
      VideointerviewScene,
      InterviewStart,
      endDefault: InterviewEnd,
      endVideoresume: EndVideoresume,
      EndSportmaster,
      BadBrowser,
      BadBrowserIos
    },

    mixins: [IEBrowserDetector, SafariBrowserDetector],

    props: {
      interview: {
        type: Object,
        default: null
      },

      isVideoresume: {
        type: Boolean,
        default: false
      },

      loading: {
        type: Boolean,
        default: false
      },

      fetch: {
        type: Function,
        default: () => {}
      },

      fromRegistration: {
        type: Boolean,
        default: false
      },

      error: {
        type: Object,
        default: () => {}
      }
    },

    data() {
      return {
        isAgreedToInterview: false,
        isMobile
      };
    },

    computed: {
      ...mapGetters('process', ['getProcessName']),

      ...mapGetters('services', ['current_domain']),

      endWay() {
        if (this.getProcessName !== undefined) {
          if (this.getProcessName === 'sportmaster_dm') {
            return 'endSportmaster';
          }
        }

        return this.isVideoresume ? 'endVideoresume' : 'endDefault';
      },

      currentLocale() {
        return this.$store.state.locale.value;
      },

      companyLogo() {
        return this.interview.vacancy && this.interview.vacancy.company
          ? this.interview.vacancy.company.logo
          : null;
      },

      vacancy_country() {
        return this.interview && this.interview.vacancy && this.interview.vacancy.country
          ? this.interview.vacancy.country.code
          : null;
      },

      company_language() {
        return this.interview.company && this.interview.company.language
          ? this.interview.company.language.code
          : '';
      },

      defaultDescription() {
        return this.$tr(`videoInterview.start.default.description`);
      },

      whichCompanyNameIs() {
        return this.interview.company
          ? this.interview.company.name
          : this.$tr(`videoInterview.start.default.companyName`);
      },

      whichUserNameIs() {
        return this.interview.candidate
          ? this.interview.candidate.name
          : this.$tr(`videoInterview.start.default.username`);
      },

      candidate() {
        return this.interview ? this.interview.candidate : null;
      },

      logo() {
        return this.interview.company ? this.interview.company.logo : null;
      },

      token() {
        return this.interview.token;
      },

      stageId() {
        return this.interview && this.interview.stage ? this.interview.stage.id : null;
      },

      isStartOrEndPage() {
        return this.isFinishedStage || !this.isAgreedToInterview;
      },

      isVideointerviewStage() {
        return ['new', 'videointerview'].indexOf(this.stageId) !== -1;
      },

      isFinishedStage() {
        return this.interview.stage.id !== 'videointerview';
      },

      isTestStage() {
        return this.stageId === 'test';
      },

      recording() {
        return this.$store.getters['interview/videointerview/recording'];
      },

      isSubmitEnabled() {
        return this.$store.getters['interview/videointerview/isSubmitEnabledProp'];
      },

      isDisable() {
        return this.error && this.error.status === HTTP_FORBIDDEN;
      },

      badBrowser() {
        if (this.isIE11OrOlder || this.defineRecordingFlow === 'notallowed') {
          return true;
        }

        return false;

        // if (this.isNewWay) {
        //   if (!this.isIos) {
        //     return this.isIE11OrOlder || this.isSafari || (this.isEdge && !this.isNewEdge);
        //   }
        //
        //   return !this.isIosSafari;
        // }
        //
        // return !this.isMobile.any ? this.isIE11OrOlder || this.isSafari || this.isEdge : false;
      },

      locale() {
        const lang = this.interview.vacancy ? this.interview.vacancy.language : null;

        return lang ? lang.code : null;
      },

      // store_url() {
      //   if (isMobile.android.device) {
      //     return 'https://play.google.com/store/apps/details?id=ru.letsee.vcv';
      //   } else if (isMobile.apple.device) {
      //     return 'https://itunes.apple.com/ru/app/vcv-запись-видеоинтервью/id694977644?mt=8';
      //   } else {
      //     return false;
      //   }
      // },

      noteLink() {
        switch (this.current_locale) {
          case 'ru':
            return 'https://www.vcv.me/ru';
          case 'ja':
          case 'jp':
            return 'https://me.vcv.ai/r/jp';
          default:
            return 'https://www.vcv.me/';
        }
      },

      current_locale() {
        return this.$store.getters['locale/current'];
      }
    },

    watch: {
      isStartOrEndPage(val) {
        this.$store.commit('interview/videointerview/isStartOrEndPageChange', val);
      },

      vacancy_country: {
        immediate: true,
        handler(val) {
          if (val) {
            this.$store.commit('interview/set_country', val);
          }
        }
      },

      company_language: {
        immediate: true,
        handler(val) {
          if (val) {
            this.$store.commit('interview/set_company_language', val);
          }
        }
      },

      isFinishedStage(val) {
        if (val) {
          if (window.gtag) {
            window.gtag({ event: 'response_received' });
          }
        }
      }
    },

    beforeMount() {
      this.$store.commit('interview/videointerview/isStartOrEndPageChange', this.isStartOrEndPage);
    },

    methods: {
      // startApp() {
      //   let appUrl = `vcv-video://interview/?token=${this.token}&host=${window.location.host}`;
      //
      //   setTimeout(() => {
      //     window.location = this.store_url;
      //   }, 500);
      //
      //   window.location = appUrl;
      // },

      agreed() {
        this.isAgreedToInterview = true;
      },

      // @TODO do not refetch, use data from test submit to switch stage
      completeInterviewTest() {
        // fetch here is bacause after test end, it is possible to show message with time limit text
        this.fetch();
      }
    }
  };
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.videointerview-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2.5rem 0;

  @media screen and (max-width: 1024px) {
    padding: 1.75rem 0 0;
    justify-content: flex-start;

    &.is-rec {
      @media only screen and (max-width: 480px) {
        padding: 1.25rem 0 0;

        .video_record_page {
          max-height: calc(100vh - 3.75rem);
        }
      }
    }
  }

  @media screen and (max-width: 480px) {
    padding-top: 1.25rem;
  }

  &.videointerview-wrapper--mobile {
    @media screen and (max-width: 1024px) and (orientation: landscape) {
      position: fixed;
      top: 0;
      left: 0;
      background: #000;
      width: 100vw;
      height: 100vh;
      overflow: hidden;
      z-index: 999999999999999;

      &:before {
        content: '';
        position: fixed;
        top: 0;
        left: 0;
        z-index: 999999999999999;
        background: #000;
        width: 100vw;
        height: 100vh;
        color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
}
.landscape-note {
  display: none;
  position: absolute;
  z-index: 9999999999999999;
  color: #fff;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;

  &.landscape-note--mobile {
    @media screen and (max-width: 1024px) and (orientation: landscape) {
      display: flex;
    }
  }
}
.video_record_page {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 0 0;
  flex: 1;
  .interview_top_block {
    text-align: center;
    margin-bottom: 2.25rem;
    @media screen and (max-width: 1024px) {
      margin-bottom: 1.5rem;
      justify-content: flex-start;
    }
    @media screen and (max-width: 480px) {
      margin-bottom: 1.25rem;
    }
  }
  .image {
    display: inline-flex;
  }
  .interview_top_block img {
    max-height: 80px;
    width: auto;

    @media screen and (max-width: 1024px) {
      max-height: 60px;
    }

    @media screen and (max-height: 1024px) {
      max-height: 60px;
    }
  }
  // &.img-block {
  //   padding: 75px 0 0;
  // }

  &.ended-block {
    display: inline-flex;
    width: auto;
    min-width: 600px;
    padding: 1.25rem 0;

    @media screen and (max-width: 1024px) {
      flex: 0;
      min-width: auto;
    }
  }
}

.is-rec {
  .video_record_page {
    .interview_top_block {
      @media only screen and (max-width: 480px) {
        display: none;
      }
    }
  }
}
@media screen and (min-width: 1200px) {
  .video_record_page {
    width: 100%;
    margin: 0 auto;
  }
}
.video_record_page_mobile {
  box-sizing: border-box;
  // min-height: calc(100vh - 84px);
  // min-height: calc(var(--vh, 1vh) * 100 - 84px);
  background: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  text-align: center;
  font-weight: 500;
  font-size: 15px;
  line-height: 22px;
  color: #233346;
  .mobile-button {
    max-width: 250px;
    margin: 0 auto;
  }
  .icon-store {
    margin: 0 auto;
    display: block;
    box-sizing: border-box;
    padding: 35px;
    max-width: 470px;
    width: 100%;
  }
}

.end-note {
  margin-top: -12px;
  margin-left: 24px;
  margin-right: 24px;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 20px;
  text-align: center;
  color: #233346;

  div {
    margin-bottom: 13px;
  }

  ::v-deep a {
    color: #bc89e6;

    &:hover {
      color: #bc89e6;
    }
  }
}

.interview-content {
  position: relative;
  display: flex;
  width: 100%;
  background: #fff;
  align-items: center;
  min-height: 37.5rem; // 600px
  padding: 0 1rem 1rem;
  box-sizing: border-box;
  box-shadow: 0px 0px 25px rgba(35, 51, 70, 0.05);
  border-radius: 2px;

  @media screen and (max-width: 1024px) {
    flex-direction: column;
    justify-content: flex-start;
    flex: 1;
    box-shadow: none;
    border-radius: 0;
    min-height: auto;
  }

  &.interview-content--end {
    min-height: auto;
  }
}

.video-container {
  max-width: 1224px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;

  @media screen and (max-width: 1024px) {
    max-width: 592px;
    flex: 1;
    align-items: flex-start;
  }

  @media only screen and (max-width: 480px) {
    align-items: stretch;
  }

  &.video-container--end {
    flex-direction: column;
    width: 100%;
    max-width: 640px;
    margin: 0 20px;

    @media screen and (max-width: 1024px) {
      align-items: center;
    }

    .interview_top_block {
      display: none;
    }

    .interview-content {
      height: auto;
      padding: 2.5rem 1rem;
    }
  }
}

.vid-int-start {
  @media screen and (max-width: 1024px) {
    flex: 1;
  }
}

.terms-wrapper {
  width: 100%;
  text-align: center;
  font-size: 15px;
  line-height: 24px;
  margin: 0.5rem auto 0;

  @media only screen and (max-width: 1024px) {
    display: none;
  }

  .terms {
    max-width: 720px;
    margin: 0 auto;
  }

  a {
    color: $green;
  }
}
</style>
